import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.assign";
import createDesignConfig from './design';
import typography from '../../lib/typography';
export default (function (_ref) {
  var design = _ref.design;
  return Object.assign({}, createDesignConfig(design), {
    typography: typography
  });
});